var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "a",
    { staticClass: "search-preview", attrs: { href: _vm.props.item.url } },
    [
      _c("span", { staticClass: "search-preview__img-wrap" }, [
        _c("img", {
          staticClass: "search-preview__img",
          attrs: { src: _vm.props.item.preview }
        }),
        _c("span", { staticClass: "search-preview__play-icon" })
      ]),
      _c("span", { staticClass: "search-preview__info" }, [
        _c("p", {
          staticClass: "search-preview__title",
          domProps: {
            innerHTML: _vm._s(
              _vm.props.fn(
                _vm.props.item.title,
                _vm.props.item.title,
                _vm.props.localsearch
              )
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-407fd4f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407fd4f2","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/parts/videos.vue
// module id = 227
// module chunks = 4